import { withInstall } from '@jdesign-vue/utils'

import Rate from './src/rate.vue'

export const JdRate = withInstall(Rate)
export default JdRate

export * from './src/rate'
